<template>
  <section class="api-info__header">
    <div class="api-name">
      <h2 class="api-code">{{ dataInfo.apiCode }}</h2>
      <p>{{ dataInfo.apiName }}</p>
    </div>
    <p class="api-remark" v-html="dataInfo.apiAcmark"></p>
    <div class="api-type flex flex-space-between">
      <p class="api-level">{{ level[dataInfo.apiCate] }}</p>
      <p class="api-creat-date">{{ "更新时间：" + dataInfo.updateTime }}</p>
    </div>
  </section>
</template>

<script>
// eslint-disable-next-line
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      level: {
        0: "基础 (免费使用)",
        1: "高级（付费）"
      }
    };
  },
  computed: {
    ...mapState({
      dataInfo: state => state.apiDoc.apiInfo
    })
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {}
};
</script>

<style lang="less">
.page-api-info {
  .api-info__header {
    .api-name {
      margin-bottom: 12px;
      font-size: 20px;
      color: @color-font-primary;

      .api-code {
        margin-bottom: 16px;
        font-size: 28px;
      }
    }
    .api-remark {
      font-size: 12px;
      color: @color-font-info;
      margin-bottom: 22px;
      white-space: pre-line;
    }
    .api-type {
      align-items: center;
      .api-level {
        color: @color-primary;
        font-size: 14px;
      }
      .api-creat-date {
        font-size: 12px;
        color: @color-font-info;
      }
    }
  }
}
</style>
